import { render } from "./InformeExtrusion.vue?vue&type=template&id=7fcb7f6b&scoped=true"
import script from "./InformeExtrusion.vue?vue&type=script&lang=js"
export * from "./InformeExtrusion.vue?vue&type=script&lang=js"

import "./InformeExtrusion.vue?vue&type=style&index=0&id=7fcb7f6b&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fcb7f6b"]])

export default __exports__